import { render, staticRenderFns } from "./sub-tab.vue?vue&type=template&id=7cc9837d&scoped=true"
import script from "./sub-tab.vue?vue&type=script&lang=js"
export * from "./sub-tab.vue?vue&type=script&lang=js"
import style0 from "./sub-tab.vue?vue&type=style&index=0&id=7cc9837d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9837d",
  null
  
)

export default component.exports